import React, { useState, useEffect, useContext, Suspense } from "react";
import { useLocation } from "react-router-dom";
import Slider from "react-slick";
import { PageSettings } from "../../config/page-settings";
import "react-magic-slider-dots/dist/magic-dots.css";
import "react-multi-carousel/lib/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-modal-video/css/modal-video.css";

const Lazyshorturl = React.lazy(() => import('./Lazyshorturl'));


const Shorturl = () => {
  const context = useContext(PageSettings);
  const location1 = useLocation().pathname;
  const mapId = location1.split('/')[1];
  useEffect(() => {
    context.handleSetPageSidebar(false);
    context.handleSetPageHeader(false);
    context.handleSetPageContentFullWidth(true);
    context.handleSetpagecontainer(false);
    return () => {
      context.handleSetPageSidebar(true);
      context.handleSetPageHeader(true);
      context.handleSetpagecontainer(true);
      context.handleSetPageContentFullWidth(false);
    };
  }, []);
  return (
    <div>
      <Suspense fallback={
        <div className="splashbg-change vh-100">
        <div className="logoimgcontainer">
          <div className="container-fluid">
            <div className="loadernew">
              <h2>Wait Please</h2>
              <img src="../assets/img/loadingblack.gif" className="gif" />
              <div className="logo">
                <img
                  src="../assets/img/logo/STT-Logo.png"
                  width="20px"
                  height="20px"
                />
                <p>STT</p>
              </div>
            </div>
          </div>
        </div>
      </div>}>
        <Lazyshorturl mapId={mapId} />
      </Suspense>
    </div>
  );
};

export default Shorturl;